import React from 'react'
import { Link } from 'react-router-dom'
import './CoreServices.scss'

function CoreServices(props) {
    return (
        <>

            <div className="row">
                <div className="serviceList">
                    <div className="services-single text-center p-5 my-md-3 my-lg-3 my-sm-0 white-bg rounded">
                        <span className="ti-desktop icon-lg color-secondary d-block mb-4"></span>
                        <h5>Website Design & Development</h5>
                        <p className="mb-0">we Design “website for every screen” so that you can reach out to wider audiences, whether they are using desktop, or mobile devises.</p>
                        <Link to="website-design-development" className="detail-link mt-4">Read more <span
                            className="ti-arrow-right"></span></Link>
                    </div>
                </div>
                <div className="serviceList">
                    <div className="services-single text-center p-5 my-md-3 my-lg-3 my-sm-0 white-bg rounded">
                        <span className="ti-shortcode icon-lg color-secondary d-block mb-4"></span>
                        <h5>Website Maintance</h5>
                        <p className="mb-0">Having Trouble with your existing website? Do you need website maintenance? Your search ends here. We do one time maintenance or provide AMC.</p>
                        <Link to="website-maintenance-service" className="detail-link mt-4">Read more <span
                            className="ti-arrow-right"></span></Link>
                    </div>
                </div>

                <div className="serviceList">
                    <div className="services-single text-center p-5 my-md-3 my-lg-3 my-sm-0 white-bg rounded">
                        <span className="ti-announcement icon-lg color-secondary d-block mb-4"></span>
                        <h5>Social Media Markeeting</h5>
                        <p className="mb-0">Social media marketing is the process of creating content that you have tailored to the context {props.social} </p>
                        <Link to="social-media-marketing" className="detail-link mt-4">Read more <span
                            className="ti-arrow-right"></span></Link>
                    </div>
                </div>
                <div className="serviceList">
                    <div className="services-single text-center p-5 my-md-3 my-lg-3 my-sm-0  white-bg rounded">
                        <span className="ti-briefcase icon-lg color-secondary d-block mb-4"></span>
                        <h5>SEO Services</h5>
                        <p className="mb-0">Increase your website ranking on Google to Improve its online potential and visibility</p>
                        <Link to="seo-service" className="detail-link mt-4">Read more <span
                            className="ti-arrow-right"></span></Link>
                    </div>
                </div>
                <div className="serviceList">
                    <div className="services-single text-center p-5 my-md-3 my-lg-3 my-sm-0 white-bg rounded">
                        <span className="ti-image icon-lg color-secondary d-block mb-4"></span>
                        <h5>Graphic Designing </h5>
                        <p className="mb-0">Let graphics speak your motive. We have a dedicated team of graphic designers</p>
                        <Link to="graphic-designing" className="detail-link mt-4">Read more <span
                            className="ti-arrow-right"></span></Link>
                    </div>
                </div>
                <div className="serviceList">
                    <div className="services-single text-center p-5 my-md-3 my-lg-3 my-sm-0 white-bg rounded">
                        <span className="ti-shopping-cart icon-lg color-secondary d-block mb-4"></span>
                        <h5>Digital Visiting Card</h5>
                        <p className="mb-0">Paper Digital Card are too traditional and old now. We offer you the exciting arena of Digital Visiting Card.</p>
                        <a href="https://dbcards.in" rel="noreferrer" target="_blank" className="detail-link mt-4">Read more <span
                            className="ti-arrow-right"></span></a>
                    </div>
                </div>
            </div>

        </>
    )
}

export default CoreServices
